import {useColorThemeType, useFontTheme} from '@buncha/appStyles/hooks/theme';

import {CustomText} from '@buncha/components/core/text';
import {Components} from '@buncha/localization/types';
import {Modules} from '@buncha/utils/types';
import React from 'react';
import {StyleSheet} from 'react-native';
import {scaleFonts} from '@buncha/appStyles/style/font';
import {useGetLocale} from '@buncha/localization/hooks';

const LegalInfo = () => {
  const theme = useColorThemeType('main');
  const muli = useFontTheme('muli');
  const {body} = useGetLocale(Modules.common, Components.components) ?? {};
  return (
    <CustomText
      style={[
        styles.text,
        {
          color: theme?.text?.gray?.[100],
          fontFamily: muli?.[600]?.normal,
        },
      ]}>
      {body?.legalInfo}
    </CustomText>
  );
};

export default React.memo(LegalInfo);

const styles = StyleSheet.create({
  text: {
    fontSize: scaleFonts(6),
    width: '90%',
    marginVertical: 5,
    alignSelf: 'center',
  },
});
